import React from 'react';
import { Box } from '@mui/material';

import { ArcDividerProps } from './types';

const ArcDivider: React.FC<ArcDividerProps> = (props) => {
  return <Box width='100%' height='0.5px' bgcolor='divider' {...props} />;
};

export default ArcDivider;